import { useTranslation } from "react-i18next";

import "./styles.css";

function WordsContainer() {
  const { t } = useTranslation();
  return (
    <div className="lp-main-about-we-made-words-container">
      <div className="lp-main-about-we-made-words">
        {t("landingPage.about.weMade.words", { returnObjects: true }).map((word, i) => (
          <span key={i}>{word}</span>
        ))}
      </div>
    </div>
  );
}

export default WordsContainer;
